import React, { useState, useEffect } from "react";
import {
  Flex,
  Text,
  Button,
  Icon,
  useToast,
  Center,
  CircularProgress,
  useDisclosure,
  Box,
} from "@chakra-ui/react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
// Legacy Apple/Google-Pay button — kept for reference, no longer rendered.
// import { SimplePay } from "../Buttons/simplePay";
import { IoTicket } from "react-icons/io5";
import { PaymentFloting } from "../../Pages/Floating/paymentFloating";
import { getStripeMode, getStripePublishableKey, getKeyError } from "../../lib/stripeMode";
import { nonHostAttendeeCount } from "../../lib/eventMoney";

export const TicketArea = ({ event, user }) => {
  const [stripePromise, setStripePromise] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const hasTicket =
    user?.uid &&
    Array.isArray(event?.members) &&
    event.members.some((ref) => ref.id === user.uid);
  const ticketPrice = Number(event?.cost) || 0;
  const formattedPrice =
    ticketPrice > 0
      ? new Intl.NumberFormat("en-CA", {
          style: "currency",
          currency: "CAD",
        }).format(ticketPrice)
      : "Free";
  const capacity = Number(event?.maxMembers) || 0;
  const spotsLeft =
    capacity > 0 ? Math.max(0, capacity - nonHostAttendeeCount(event)) : null;

  useEffect(() => {
    const initializeStripe = async () => {
      const keyError = getKeyError();
      if (keyError) {
        console.error("[Stripe] " + keyError);
        toast({
          title: "Payments not configured",
          description: keyError,
          status: "error",
          duration: 8000,
          isClosable: true,
        });
        return;
      }
      console.log(`[Stripe] Loading publishable key in ${getStripeMode()} mode`);
      const stripe = await loadStripe(getStripePublishableKey());
      setStripePromise(stripe);
    };

    initializeStripe().catch((error) =>
      console.error("Stripe init error:", error)
    );
  }, [event.memberData.accountId, toast]);

  if (!stripePromise) {
    return (
      <Center py={4}>
        <CircularProgress isIndeterminate color="#508cf7" />
      </Center>
    );
  }

  return (
    <>
      {stripePromise && (
        <Elements stripe={stripePromise}>
          <Flex
            my={4}
            p={3}
            borderRadius="14px"
            flexDirection="column"
            bg="#F3F8FE"
            gap={3}
          >
            <Flex align="center" justify="space-between" gap={3}>
              <Flex align="center" gap={3} minW={0}>
                <Flex
                  boxSize="40px"
                  minW="40px"
                  borderRadius="12px"
                  bg="white"
                  align="center"
                  justify="center"
                >
                  <Icon as={IoTicket} fontSize="18px" color="#508cf7" />
                </Flex>
                <Box minW={0}>
                  <Text fontWeight="800" fontSize="14px" color="gray.800">
                    {hasTicket ? "Your ticket is ready" : "Reserve your ticket"}
                  </Text>
                  <Text fontWeight="600" fontSize="12px" color="gray.500">
                    {spotsLeft !== null
                      ? spotsLeft === 0
                        ? "No spots left"
                        : `${spotsLeft} spot${spotsLeft === 1 ? "" : "s"} left`
                      : "Secure your spot for this hangout"}
                  </Text>
                </Box>
              </Flex>
              <Text fontWeight="900" fontSize="16px" color="gray.900" whiteSpace="nowrap">
                {formattedPrice}
              </Text>
            </Flex>

            <Flex>
              {/* <SimplePay /> */}

              <Button
                onClick={onOpen}
                w={"100%"}
                bg={"#508cf7"}
                size="md"
                color={"white"}
                fontSize={"14px"}
                fontWeight="800"
                _hover={{ bg: "#226cf1" }}
                borderRadius={"12px"}
                h="46px"
              >
                {hasTicket ? "View Ticket" : "Get Tickets"}
              </Button>
            </Flex>
          </Flex>
          <PaymentFloting
            isOpen={isOpen}
            onClose={onClose}
            event={event}
            user={user}
          />
        </Elements>
      )}
    </>
  );
};
